import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { NotFound } from "../modules/404";
import { UsersRouter } from "../modules/users/users.router";
import { Shops } from "../modules/shops/pages";
import { ShopsRouter } from "../modules/shops/shops.router";

export const AdminRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Shops />} />
          </Route>
          {UsersRouter}
          {ShopsRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
